import { createContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  HomeRepairService,
  Apartment,
  Campaign,
  LocalLaundryService,
  DoorSliding,
  Group,
  Contacts,
  DocumentScanner,
  Store,
  Storefront,
  ListAlt,
  Bookmarks,
  HolidayVillage,
} from '@mui/icons-material';
import NavItem from '../components/Sidebar/NavItem';

import User from '../components/Sidebar/User';
import { isNavGroup, NavGroup, NavItemGroup, NavItemLink } from '../components/Sidebar/NavGroup';

export type NavegableItem = NavItemLink | NavItemGroup;

const defaultNavigationItems: NavegableItem[] = [
  /** TODO: construct dashboard page */
  // { title: 'dashboard', to: '/', icon: <Dashboard />, disabled: true },
  { title: 'condomínios', to: '/condominiums', icon: <Apartment /> },
  { title: 'lavanderias', to: '/laundries', icon: <LocalLaundryService /> },
  {
    title: 'lojas',
    icon: <Store />,
    items: [
      { title: 'grupo de lojas', to: '/shop-groups', icon: <HolidayVillage /> },
      { title: 'lista de lojas', to: '/shops', icon: <ListAlt /> },
    ],
  },
  { title: 'mercados', to: '/markets', icon: <Storefront /> },
  { title: 'armários', to: '/lockers', icon: <DoorSliding /> },
  { title: 'pessoas', to: '/persons', icon: <Group /> },
  { title: 'parceiros', to: '/contractors', icon: <Contacts /> },
  { title: 'termos', to: '/terms', icon: <DocumentScanner /> },
  { title: 'serviços', to: '/services', disabled: true, icon: <HomeRepairService /> },
  { title: 'posts', to: '/posts', disabled: true, icon: <Campaign /> },
];

export function getRouteName(path: string) {
  return path.replace(/^\/([^/]*).*$/, '$1');
}

interface NavigationContextProps {
  items: JSX.Element;
  isDrawerMini: boolean;
  setIsDrawerMini: (value: boolean) => void;
  setItems: (children: JSX.Element) => void;
  reset: () => void;
}

const DefaultNav = (): JSX.Element => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <>
      <User />
      {defaultNavigationItems.map((item) => {
        if (isNavGroup(item)) {
          const isActive = item.items.some((subItem) => pathname === subItem.to);
          return <NavGroup {...item} key={item.title} active={isActive} />;
        }
        return (
          <NavItem
            {...item}
            key={item.title}
            active={pathname === item.to}
            onClick={() => {
              navigate(item.to);
            }}
          />
        );
      })}
    </>
  );
};

export const NavigationContext = createContext<NavigationContextProps>({} as NavigationContextProps);

export const NavigationProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [isDrawerMini, setIsDrawerMini] = useState(true);
  const [items, setItems] = useState<JSX.Element>(<DefaultNav />);

  const reset = () => {
    setItems(<DefaultNav />);
  };

  return (
    <NavigationContext.Provider value={{ items, setItems, reset, isDrawerMini, setIsDrawerMini }}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;
